import { runClientComponent } from '../../_common/client/client-component-runner';
import { RedirectMessageComponent } from './redirect-message.component';

runClientComponent({ RedirectMessageComponent });
